/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown> }} Usage_Tab_Pages_RemainingInputs */



/**
* | output |
* | --- |
* | "{remaining} pages remaining this month" |
*
* @param {Usage_Tab_Pages_RemainingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const usage_tab_pages_remaining = /** @type {((inputs: Usage_Tab_Pages_RemainingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Tab_Pages_RemainingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.remaining} Seiten diesen Monat übrig`)
	return /** @type {LocalizedString} */ (`${i?.remaining} pages remaining this month`)
});